<template>
	<div class="other-loyalty-discount">
		<v-row justify="center">
			<v-col cols="6">
				<v-card class="" outlined>
					<v-card-title class="text-h3">
						Loyalty Discount
					</v-card-title>

					<v-card-text class="text-h4">
						Maximize Your Purchasing Power with the Loyalty Discount Program
					</v-card-text>

					<v-card-text>
						<p>
							In B2B cooperation, predictability and cost optimization are key to growing your business.
							That
							is why we are shifting away from recalculating your discounts from scratch with every single
							order.
						</p>
						<p>
							With our new Loyalty Discount Program, your earned discount level is fully secured, giving
							you
							the financial stability and peace of mind you need to plan your inventory.
						</p>
						<p style="font-weight: bold;">How It Works - The Rules are Simple:</p>
						<ul class="mb-8">
							<li>
								<strong>Lock In Your Discount</strong>: Whenever you place an order, your current
								discount rate is automatically secured for the next 2 months (60 days) from the shipment
								date.
							</li>
							<li>
								<strong>Maintain with Any Value</strong>: To keep this discount active for future
								purchases, simply place another order within this 2-month window. There is no minimum
								order value required to extend your protection period.
							</li>
							<li>
								<strong>Automatic Extensions</strong>: Every time a new order is shipped, your 2-month
								protection window resets and starts fresh. Your preferential rates are automatically
								calculated and visible directly in your B2B panel.
							</li>
						</ul>
						<p style="font-weight: bold;">Grow Your Benefits (Level Up Your Discount):</p>
						<p>Business is dynamic, and we want to reward your growth. If you place an order within the
							2-month protection period that qualifies for a higher discount tier based on our regular
							volume scales:</p>
						<ul>
							<li>
								You immediately upgrade to the higher discount level.
							</li>
							<li>
								This new, higher rate becomes your protected baseline for the next 2 months.
							</li>
							<li>
								You can continue to extend and maintain this upgraded discount using the same simple
								rule (any order within 60 days).
							</li>
						</ul>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

	</div>
</template>
<script>

export default {
	name: 'OtherLoyaltyDiscount',
	components: {},
	computed: {},
	data: () => ({}),
	methods: {},
	created() {
	}
};
</script>
